import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { where } from "firebase/firestore";
import { Coverage } from "risa-data-model";

import { FirestoreService } from "../../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../shared/api/firebase/references";
import { DataState } from "../../store/store";
const initialPatientResponsibilityAmountState: DataState<number | null> = {
  loading: false,
  error: null,
  data: null,
};

const patientResponsibilitySummarySlice = createSlice({
  name: "PatientResponsibilitySummarySlice",
  initialState: initialPatientResponsibilityAmountState,
  reducers: {
    setPatientResponsibilitySummaryData(
      state: DataState<number>,
      action: PayloadAction<number | null>,
    ) {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
    },
    setError(state: DataState<number>, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    setLoading(state: DataState<number>, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    resetPatientResponsibilitySummaryData(state: DataState<number>) {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  setPatientResponsibilitySummaryData,
  setError,
  setLoading,
  resetPatientResponsibilitySummaryData,
} = patientResponsibilitySummarySlice.actions;

export const getPatientResponsibilityForSummaryAmount =
  (orderId: string) => async (dispatch: any) => {
    const data = FirestoreService.listenToQueryCollection<Coverage>(
      FirestoreCollectionReference.coverage(orderId),
      (documents) => {
        let totalAmount = -1;
        if (documents.length === 0) {
          dispatch(setPatientResponsibilitySummaryData(null));
        } else {
          const patientResponsibilities =
            documents[documents.length - 1].PatientResponsibilities;
          if (patientResponsibilities) {
            Object.entries(patientResponsibilities).forEach(([_, value]) => {
              if (totalAmount < 0) {
                totalAmount += 1;
              }
              totalAmount += Number(value.PatientResponsibility);
            });
          }
          if (totalAmount < 0) {
            dispatch(setPatientResponsibilitySummaryData(null));
          } else {
            dispatch(setPatientResponsibilitySummaryData(totalAmount));
          }
        }
      },
      (error: any) => {
        dispatch(setError(error.message));
      },
      where("IsEligible", "==", true),
    );
    return data;
  };

export default patientResponsibilitySummarySlice.reducer;
